import { render, staticRenderFns } from "./UploadEvidenceFile.vue?vue&type=template&id=b0185506&scoped=true&"
import script from "./UploadEvidenceFile.vue?vue&type=script&lang=js&"
export * from "./UploadEvidenceFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadEvidenceFile.vue?vue&type=style&index=0&id=b0185506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0185506",
  null
  
)

export default component.exports